import Script from 'next/script'
import React, {useEffect, useState} from "react";
import "../[slug]/request.scss"
import {useToast} from "@/components/use-toast";
import Head from "next/head";

export default function Index() {
    const [isLoading, setIsLoading] = useState(true)
    const {toast} = useToast()
    useEffect(() => {
        setTimeout(() => setIsLoading(!isLoading), 5000)
    }, []);

    return (
        <>
            <Head>
                <title>Become a mentor</title>
                <meta property="og:site_name" content="Expat Pie"/>
                <meta property="og:title" content="Become a mentor" />
                <meta property="og:description" content="Join Expat Pie as a mentor and help expats navigate their career and relocation journeys. Apply to become a mentor and share your expertise with those seeking guidance in the tech industry." />
                <meta property="og:url" content="https://expatpie.com/become-mentor" />
                <meta name="description" content="Join Expat Pie as a mentor and help expats navigate their career and relocation journeys. Apply to become a mentor and share your expertise with those seeking guidance in the tech industry." />
            </Head>
            <main className="min-h-screen pt-6 pb-[120px]">
                <div className="flex flex-col items-center">
                    {isLoading && <div className="load-bar relative w-full h-1 bg-white-68">
                        <div className="bar inline absolute w-0 h-full left-1/2 text-center content-['']"></div>
                        <div className="bar inline absolute w-0 h-full left-1/2 text-center content-['']"></div>
                    </div>}
                    <div className="w-full lg:w-4/5 lg:max-w-[1103px] px-9 relative">
                        <iframe
                            data-tally-src="https://tally.so/embed/nPAEOV?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                            // @ts-ignore
                            loading="lazy" width="100%" height="958" frameBorder="0" marginHeight="0" marginWidth="0"
                            title="Request a session"></iframe>
                        <Script
                            id="tally-js"
                            src="https://tally.so/widgets/embed.js"
                            onLoad={() => {
                                // @ts-ignore
                                Tally.loadEmbeds();
                            }}
                            onError={() => {
                                toast({
                                    className: "bg-darker",
                                    variant: "destructive",
                                    title: "Uh oh! Something went wrong.",
                                    description: "Fail to fetch form. please try again later",
                                })
                            }}
                        />
                        <div
                            className="absolute right-9 bottom-[15px] min-[550px]:w-[190px] w-[50px] h-[45px] z-50 bg-blur-100">
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
